import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { MessageService } from '../../../../services/message-service/message.service';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { HerkunftsbetriebFilter } from './gruppe-tier-herkunft-filter';

@Component({
    selector: 'kiene-gruppe-tier-herkunft-filter',
    templateUrl: './gruppe-tier-herkunft-filter.component.html',
    styleUrls: ['./gruppe-tier-herkunft-filter.component.scss'],
})
export class GruppeTierHerkunftFilterComponent implements OnInit, OnDestroy, OnChanges {
    herkunftSubscription: Subscription;
    isLoading = true;
    label = 'Lädt...';

    @Input('gruppeId') selectedGruppeId: number;
    @Input() gruppeIds: number[] = [];
    @Input('herkunftsbetriebe') herkunftsbetriebe: HerkunftsbetriebFilter[] = [];
    @Input('hideOnEmptyList') hideOnEmptyList = false;

    @Output('selectedHerkunftsbetriebe') selectedHerkunftsbetriebe: EventEmitter<HerkunftsbetriebFilter[]> =
        new EventEmitter<HerkunftsbetriebFilter[]>();
    selectedHerkunftCtrl: UntypedFormControl = new UntypedFormControl(null);
    herkunftFuerGruppe: HerkunftsbetriebFilter[] = [];

    constructor(
        private readonly messageService: MessageService,
        private readonly stammdatenService: StammdatenService,
    ) {}

    ngOnDestroy(): void {
        this.herkunftSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.selectedHerkunftCtrl.disable();
        this.loadHerkunftFuerGruppe();
        this.selectedHerkunftCtrl.setValue(this.herkunftsbetriebe);
        this.selectedHerkunftCtrl.valueChanges.subscribe((value: HerkunftsbetriebFilter[]) => {
            this.selectedHerkunftsbetriebe.emit(value);
        });
    }

    ngOnChanges() {
        this.loadHerkunftFuerGruppe();
    }

    resetHerkunftCtrl($event: MouseEvent) {
        $event.stopPropagation();
        this.selectedHerkunftCtrl.setValue(undefined);
    }

    loadHerkunftFuerGruppe() {
        const targetGroupIds =
            (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0).length > 0
                ? (this.gruppeIds || []).map(id => Number(id)).filter(id => id > 0)
                : this.selectedGruppeId
                  ? [Number(this.selectedGruppeId)]
                  : [];
        if (targetGroupIds.length > 0) {
            this.isLoading = true;
            this.herkunftSubscription?.unsubscribe();
            const requests = targetGroupIds.map(gruppeId => this.stammdatenService.ladeHerkunftsbetriebe(gruppeId));
            this.herkunftSubscription = forkJoin(requests).subscribe({
                next: result => {
                    this.selectedHerkunftCtrl.enable();
                    this.isLoading = false;
                    const byId = new Map<number, HerkunftsbetriebFilter>();
                    for (const res of result || []) {
                        for (const item of res?.records || []) {
                            const key = Number(item?.herkunft_kunde_id || 0);
                            if (key <= 0 || byId.has(key)) {
                                continue;
                            }
                            byId.set(key, item);
                        }
                    }
                    this.herkunftFuerGruppe = Array.from(byId.values());

                    if (this.herkunftFuerGruppe.length === 0) {
                        this.label = 'keine Herkunftsbetriebe';
                        this.selectedHerkunftCtrl.disable();
                    } else {
                        this.label = 'Herkunftsbetrieb';
                    }
                },
                error: err => {
                    this.isLoading = false;
                    this.messageService.errorMessage('Fehler beim Laden der Herkunftsbetriebe', err);
                },
            });
        }
    }

    compareHerkunft(a: HerkunftsbetriebFilter, b: HerkunftsbetriebFilter) {
        return a && b && a.herkunft_kunde_id === b.herkunft_kunde_id;
    }

    displayLabel(item: HerkunftsbetriebFilter): string {
        const name = (item?.herkunft_betrieb || '').trim() || 'Unbekannt';
        const vvvo = (item?.herkunft_vvvo || '').trim();
        return vvvo ? `${name} (${vvvo})` : name;
    }
}
